<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items-per-page="5"
            :items="deserts"
            >
            <template v-if="canEdit" v-slot:top>
                
                <v-toolbar flat color="white">
                    <v-toolbar-title>เพิ่มรายละเอียดรายการซ่อม</v-toolbar-title>
                </v-toolbar>
                
                <v-divider
                    class="mx-4"
                    inset
                    ></v-divider>
                <v-form ref="formDetail" v-model="validDetail" lazy-validation>
                    <v-row class="ml-2">
                        <v-col>
                            <v-autocomplete
                                :rules="[rules.required]"
                                v-model="editedItem.serviceCode"
                                :items="serviceList"
                                item-text="display"
                                item-value="value"
                                outlined 
                                placeholder="พิมพ์รหัส หรือ ชื่อรายการซ่อม"
                                label="รายละเอียดรายการซ่อม">
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="2"><v-text-field ref="qty" outlined placeholder=" " :rules="[rules.requiredNumber]" label="จำนวน" maxlength="4" v-model="editedItem.qty"></v-text-field></v-col>
                        <v-col cols="2"><v-text-field outlined placeholder=" " :rules="[rules.requiredNumber]" label="ราคา/หน่วย" v-model="editedItem.unitPrice"></v-text-field></v-col>
                        <v-col cols="2"><v-text-field outlined placeholder=" " :rules="[rules.requiredMaxNumber(100)]" label="ส่วนลด" maxlength="6" v-model="editedItem.discountPercent"></v-text-field></v-col>
                        <v-col cols="2" md="3">
                            <v-btn class="ma-2" color="primary" @click="saveDetail">{{lblSave}}</v-btn>
                            <v-btn class="ma-2" color="primary" @click="closeDialog"> {{lblCancel}}</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
            <template v-slot:header.discount>
                <thead>
                    <tr>
                        <th colspan="2" class="text-center">ส่วนลด</th>
                    </tr>
                    <tr>
                        <th class="text-center">%</th>
                        <th class="text-center">ยอด</th>
                    </tr>
                </thead>
            </template>

            <template v-slot:[`item.discount`]="{item}">
                <tr>
                    <th class="text-center">{{item.discountPercentDisplay}}</th>
                    <th class="text-center">{{item.discountPriceDisplay}}</th>
                </tr>
            </template>
            
            <template v-if="canEdit" v-slot:[`item.action`]="{ item }">
                <v-icon
                        small
                        @click="editItem(item)"
                        :disabled=isEditMode
                    >
                        edit
                    </v-icon>
                    <v-icon
                        small
                        @click="deleteItem(item)"
                        :disabled=isEditMode
                    >
                        delete
                    </v-icon>
                </template>
        </v-data-table>
    </v-container>
</template>

<script>
import {listDropdownBpeService} from '@/api/common/dropdown-api.js'
import rules from '@/assets/js/rules.js'
import numeral from 'numeral'

export default {
    name: 'BpeServiceDetail',
    props: ["currentItems", "canEdit"],
    computed: {
        lblCancel() {
            return this.editedIndex == -1 ? "ล้าง" : "ยกเลิก";
        },
        lblSave() {
            return this.editedIndex == -1 ? "เพิ่ม": "บันทึก";
        },
        deserts() {
            let o = this.currentItems ? this.currentItems : this.items;
            return o;
        }
    },
    watch: {
        items: {
            handler(data){
                this.$emit("syncBpeServiceDetail", data);
            },
            deep: true
        },
        currentItems(val) {
            if (val) this.items = val;
        },
        discount(val) {
            if (val && val == 0) {
                this.editedItem.discountPercent = 0;
            } else {
                this.editedItem.discountPercent = val;
            }
        }
    },
    data: () => ({
        discount: 0,
        headers: [
            {text: 'No.', value: 'seq'},
            {text: 'รหัสงานซ่อม', value: 'serviceCode'},
            {text: 'รายการซ่อม', value: 'serviceName'},
            {text: 'จำนวน', value: 'qty', align: 'right'},
            {text: 'ราคา/หน่วย', value: 'unitPriceDisplay', align: 'right'},
            {text: 'ยอดรวม', value: 'totalDisplay', align: 'right'},
            {text: 'ส่วนลด(%)', value: 'discountPercentDisplay', align: 'right'},
            {text: 'รวมสุทธิ', value: 'grandTotalDisplay', align: 'right'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        rules: rules,
        items: [],
        isEditMode: false,
        editedIndex: -1,
        editedItem: {
            seq: 0,
            serviceCode: '',
            serviceName: '',
            qty: '',
            unitPrice: '',
            total: 0,
            discountPercent: '',
            discountPrice: '',
            grandTotal: 0,
            dirty: false
        },
        defaultItem: {
            seq: 0,
            serviceCode: '',
            serviceName: '',
            qty: '',
            unitPrice: '',
            total: 0,
            discountPercent: '',
            discountPrice: '',
            grandTotal: 0,
            dirty: false
        },
        validDetail: false,
        serviceList: []
    }),
    methods: {
        calulateDiscount() {
            //this.editedItem.discountPercent = this.discount;
            this.editedItem.total = this.editedItem.qty * this.editedItem.unitPrice;
            this.editedItem.discountPrice = this.editedItem.discountPercent == 0 ? 0 : this.editedItem.total * this.editedItem.discountPercent / 100;
            this.editedItem.grandTotal = this.editedItem.total - this.editedItem.discountPrice;
            this.setDisplay(this.editedItem);
        },
        setDisplay(obj) {
            obj.discountPercentDisplay = numeral(obj.discountPercent).format('0,0.00');
            obj.totalDisplay = numeral(obj.total).format('0,0.00');
            obj.discountPriceDisplay = numeral(obj.discountPrice).format('0,0.00');
            obj.grandTotalDisplay = numeral(obj.grandTotal).format('0,0.00');
            obj.unitPriceDisplay = numeral(obj.unitPrice).format('0,0.00');
        },
        saveDetail() {
            if (!this.$refs.formDetail.validate()) {
                this.bpe.estimateNo.focus();
                return;
            }
            
            
            this.editedItem.dirty = true;
            this.calulateDiscount();
            let obj = this.serviceList.find(e => e.value == this.editedItem.serviceCode);
            if (obj) {
                this.editedItem.serviceName = obj.name;
                this.editedItem.unitPriceDisplay = numeral(this.editedItem.unitPrice).format('0,0.00');
                if (this.editedIndex == -1) {
                    this.editedItem.seq = this.items.length + 1;
                    this.items.push(this.editedItem);
                } else {
                    Object.assign(this.items[this.editedIndex], this.editedItem);
                }
                
                this.closeDialog();
            }
             
        },
        closeDialog() {
            this.isEditMode = false;
            this.editedIndex = -1;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedItem.discountPercent = this.discount;
            });
        },
        editItem (item) {
             this.isEditMode = true;
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = {
                estimateServiceId: item.estimateServiceId,
                seq: item.seq,
                serviceCode: item.serviceCode,
                serviceName: item.serviceName,
                qty: item.qty,
                unitPrice: item.unitPrice,
                discountPercent: item.discountPercent
            };
        },
        deleteItem (item) {
            if (!confirm("คุณต้องการลบข้อมูลใช่หรือไม่ ?")) {
                return
            }
            const index = this.items.indexOf(item);
            this.items.splice(index, 1);
        },
        clearData() {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.items = [];
            this.editedIndex = -1;
        },
        setDiscount(val) {
            this.discount = val;
        }
    },
    mounted() {
        if (!this.editMode) {
            this.$loading(true);
            listDropdownBpeService().then(rs => {
                this.$loading(false);
                this.serviceList = rs;
            })
        }
    }
}
</script>